import clsx from 'clsx'
import { Button } from '@asad/ui'
import { t } from 'i18next'

type GlobalErrorProps = {
  title: string
  description: string
  resetError?: () => void
  imgData: { src: string; alt: string }
}

const GlobalError = ({ title, description, imgData, resetError }: GlobalErrorProps) => {
  const handleGoHome = () => {
    if (resetError) resetError()
    window.location.href = '/'
  }

  return (
    <div
      className={clsx(
        'dark:bg-background-general-dark bg-background-general-light dark:text-text-dark text-text-light flex flex-col items-center text-center justify-center min-h-screen p-8 gap-4',
      )}
    >
      <h1 className='text-2xl font-bold text-foreground mb-4'>😢 {title}</h1>
      {<img src={imgData.src} alt={imgData.alt} className='max-w-130 px-4' />}
      <p className='text-lg mb-8'>{description}</p>
      <Button onClick={handleGoHome}>{t('error.goBackHome')}</Button>
    </div>
  )
}

export default GlobalError
